import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { OperatoriInstitutiiComponent } from './operatori-institutii.component';
import { AddOperatoriInstitutiiComponent } from './add-operatori-institutii/add-operatori-institutii.component';
import { EditOperatoriInstitutiiComponent } from './edit-operatori-institutii/edit-operatori-institutii.component';

@NgModule({
    declarations: [
        OperatoriInstitutiiComponent,
        AddOperatoriInstitutiiComponent,
        EditOperatoriInstitutiiComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ]
})
export class OperatoriInstitutiiModule { }
